/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerId } from './lecturerId';
import type { LecturerAvatar } from './lecturerAvatar';

/**
 * Lecturer that can be author or corrector of a module
 */
export interface Lecturer {
  id?: LecturerId;
  name: string;
  title: string;
  firstname: string;
  lastname: string;
  avatar?: LecturerAvatar;
}
